module.exports = __webpack_public_path__ + "img/27.3999a319.jpg";